let appMode = process.env.REACT_APP_ENV;
let ASSET_URL = "http://localhost:7900/";
let URL;

console.log("appMode", appMode);

if (appMode === "development") {
  URL = process.env.REACT_APP_DEV_API_BASE_URL;
  ASSET_URL = process.env.REACT_APP_DEV_API_LOCAL_ASSET_URL;
} else {
  URL = process.env.REACT_APP_PROD_API_BASE_URL;
  ASSET_URL = process.env.REACT_APP_PROD_API_ASSET_URL;
}

let apiPath = {
  baseURL: URL,
  assetURL: ASSET_URL,
  dashboard: "admin/dashboard",
  login: "admin/auth/login",
  refreshToken: "admin/auth/refresh-token",
  logout: "admin/auth/logout",
  adminLoginActivity: "admin/login-activity",

  profile: "admin/auth/get-profile",
  updateProfile: "admin/auth/update-profile",
  changePassword: "admin/auth/change-password",

  forgotPassword: "admin/auth/forgot-password",
  verifyOTP: "admin/auth/verify-otp",
  resetPassword: "admin/auth/reset-password",

  // Customer APIs
  listCustomer: "admin/customer",
  checkCustomerUserName: "admin/customer/check-user-name",

  // Enquiry APIs
  listEnquiry: "admin/enquiries",
  enquiryStatus: "admin/enquiries",

  // Newsletter APIs
  newsletter: "admin/newsletter",
  newsletterStatus: "admin/newsletter/status",

  // Leadership APIs
  listLeadership: "admin/leadership",

  //CMS
  listCms: "admin/cms",

  //bannner API
  banner: "admin/banner",
  statusBanner: "admin/banner/status",

  // FAQ APIs
  listFaq: "admin/faq",
  statusFaq: "admin/faq/status",

  // Content APIs
  content: "admin/content",

  // EmailTemplate APIs
  listEmailTemplate: "admin/email-template/list",
  addEditEmailTemplate: "admin/email-template/add-edit",
  deleteEmailTemplate: "admin/email-template",
  statusEmailTemplate: "admin/email-template/status",
  viewEmailTemplate: "admin/email-template/view",

  // Email Logs APIs
  listEmailLogs: "admin/email-logs",
  viewEmailLog: "admin/email-logs",

  //category
  listCategory: "admin/category",
  statusCategory: "admin/category/status",

  // Vendor
  vendor: "admin/vendors",
  statusVendor: "admin/vendors/status",

  //Occasion
  listOccasion: "admin/occasion",
  statusOccasion: "admin/occasion/status",

  //Diary
  listDiary: "admin/diary",
  statusDiary: "admin/diary/status",

  // sub category
  listSubCategory: "admin/sub-category",
  statusSubCategory: "admin/sub-category/status",

  // keyword emotion
  keywordEmotion: "keyword-emotion",

  // Inventory
  product: "admin/product",
  affiliateRuns: "admin/affiliate/runs",
  affiliateStatus: "admin/affiliate/status",
  digitalDocuments: "admin/digital-documents",
  variant: "admin/variant",
  stockTracking: "admin/stock-tracking",
  cart: "admin/carts",
  orders: "admin/orders",
  scraper: "scraper",

  // Settings
  listSettings: "admin/setting",
  addEditSettings: "admin/setting",

  // Settings
  listMasters: "admin/master",
  addEditMasters: "admin/master",

  // SEO apis
  listSeo: "admin/seo",

  common: {
    categories: "common/categories",
    subCategories: "common/sub-categories",
    products: "common/products",
    getUsers: "common/customer",
    getOccasion: "common/occasion",
    imageUpload: "common/image-upload",
    getSeo: "seo",
  },
};

export default apiPath;
